module.exports = __webpack_public_path__ + "static/media/jump-page-de.abfbc42d.png";